

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API, Project, ProjectAPI } from '@brg/api';
import { DefaultHandler } from '../components/__ADDONS__/__SAFEAPI__/Handle';
import { Endpoints } from '@brg/api';
import i18next from 'i18next';

export const fetchResearch = createAsyncThunk(
    'research/fetchResearch',
    async ({
        idCompetition,
        projectFilter,
        lang,
    }: {
        idCompetition: string;
        projectFilter?: number;
        lang?: string;
    }) => {
        const json = (
            await API.Json(
                ProjectAPI.GetCollectionByCompetitionId({
                    idCompetition,
                    projectStatus: 1,
                    projectFilter: projectFilter ?? 1,
                }),
            )
        ).map(DefaultHandler.defaultProject as any);
        return lang ? (API.lang(json, lang) as any) : json;
    },
);

export const fetchFilter = createAsyncThunk('research/fetchFilter', async (args: any) => {
    const urlParams = new URLSearchParams();
    Object.keys(args).forEach((key) => {
        if (args[key] instanceof Array) {
            for (const val of args[key]) {
                if (val.toString() === '[object Object]') continue;
                urlParams.append(key, val);
            }
        } else {
            if (args[key].toString() !== '[object Object]') urlParams.append(key, args[key]);
        }
    });
    const ft = (
        await (
            await API.fetch(Endpoints.geograffee + '/api/Project/GetProjectsByFilter?' + urlParams.toString(), {})
        ).json()
    ).map(DefaultHandler.defaultProject);
    const json = API.lang(ft, i18next.language);
    return json;
});

export interface ResearchSliceState {
    projects: Project[];
    loading: boolean;
}
const researchSlice = createSlice({
    name: 'research',
    initialState: {
        projects: [],
        loading: false,
    },
    reducers: {},
    extraReducers: {
        [fetchResearch.fulfilled.toString()]: (state, action) => {
            state.projects = action.payload;
            state.loading = false;
        },
        [fetchResearch.rejected.toString()]: (state) => {
            state.loading = false;
        },
        [fetchResearch.pending.toString()]: (state) => {
            state.loading = true;
        },
        [fetchFilter.fulfilled.toString()]: (state, action) => {
            state.projects = action.payload;
            state.loading = false;
        },
        [fetchFilter.rejected.toString()]: (state) => {
            state.loading = false;
        },
        [fetchFilter.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default researchSlice;
export const selectResearch = (state: any): ResearchSliceState => state.research;


import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API, Project, ProjectAPI } from '@brg/api';
import { DefaultHandler } from '../components/__ADDONS__/__SAFEAPI__/Handle';
import { Endpoints } from '@brg/api';
import i18next from 'i18next';

export const fetchResearch = createAsyncThunk(
    'research/fetchResearch',
    async ({
        idCompetition,
        projectFilter,
        lang,
    }: {
        idCompetition: string;
        projectFilter?: number;
        lang?: string;
    }) => {
        const json = (
            await API.Json(
                ProjectAPI.GetCollectionByCompetitionId({
                    idCompetition,
                    projectStatus: 1,
                    projectFilter: projectFilter ?? 1,
                }),
            )
        ).map(DefaultHandler.defaultProject as any);
        return lang ? (API.lang(json, lang) as any) : json;
    },
);

export const fetchFilter = createAsyncThunk('research/fetchFilter', async (args: any) => {
    const urlParams = new URLSearchParams();
    Object.keys(args).forEach((key) => {
        if (args[key] instanceof Array) {
            for (const val of args[key]) {
                if (val.toString() === '[object Object]') continue;
                urlParams.append(key, val);
            }
        } else {
            if (args[key].toString() !== '[object Object]') urlParams.append(key, args[key]);
        }
    });
    const ft = (
        await (
            await API.fetch(Endpoints.geograffee + '/api/Project/GetProjectsByFilter?' + urlParams.toString(), {})
        ).json()
    ).map(DefaultHandler.defaultProject);
    const json = API.lang(ft, i18next.language);
    return json;
});

export interface ResearchSliceState {
    projects: Project[];
    loading: boolean;
}
const researchSlice = createSlice({
    name: 'research',
    initialState: {
        projects: [],
        loading: false,
    },
    reducers: {},
    extraReducers: {
        [fetchResearch.fulfilled.toString()]: (state, action) => {
            state.projects = action.payload;
            state.loading = false;
        },
        [fetchResearch.rejected.toString()]: (state) => {
            state.loading = false;
        },
        [fetchResearch.pending.toString()]: (state) => {
            state.loading = true;
        },
        [fetchFilter.fulfilled.toString()]: (state, action) => {
            state.projects = action.payload;
            state.loading = false;
        },
        [fetchFilter.rejected.toString()]: (state) => {
            state.loading = false;
        },
        [fetchFilter.pending.toString()]: (state) => {
            state.loading = true;
        },
    },
});

export default researchSlice;
export const selectResearch = (state: any): ResearchSliceState => state.research;
